"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[497],{

/***/ 14399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GlobalStyle; }
/* harmony export */ });
/* harmony import */ var _styled_system_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26273);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  body {\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .createGlobalStyle */ .vJ)(_templateObject(), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    body: {
        color: "pigeon700",
        backgroundColor: "#F6F6F6",
        fontFamily: "copy"
    }
}));


/***/ }),

/***/ 46955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ BlogRoutes; },
/* harmony export */   "Z5": function() { return /* binding */ Routes; },
/* harmony export */   "aY": function() { return /* binding */ SocialMediaRoutes; },
/* harmony export */   "qh": function() { return /* binding */ SharedRoutes; },
/* harmony export */   "t5": function() { return /* binding */ AuthRoutes; }
/* harmony export */ });
/* unused harmony exports MailToRoutes, AppRoutes, DynamicRoutes, BlogDynamicRoutes */
/**
 * These are routes that are shared with app. Make sure to keep this up to date with app.
 */ var SharedRoutes = {
    appStore: "https://itunes.apple.com/app/apple-store/id1244558410?pt=118626354&ct=aircamwebsite&mt=8",
    helpCenter: "https://help.air.inc",
    playStore: "https://play.google.com/store/apps/details?id=com.airapp.android",
    releases: "https://www.notion.so/aircamera/What-s-New-1d5da1c7779a4e71a94971834d5cdf0e",
    status: "https://status.air.inc/"
};
/**
 * These are routes that start with `mailto:`
 */ var MailToRoutes = {
    hello: "mailto:hello@air.inc",
    prr: "mailto:pr@air.inc"
};
var AppRoutes = {
    library: "/library"
};
/**
 * These are social media routes.
 */ var SocialMediaRoutes = {
    github: "https://github.com/AirLabsTeam",
    instagram: "https://instagram.com/air.hq",
    linkedIn: "https://www.linkedin.com/company/airhq/",
    tiktok: "https://www.tiktok.com/@meetair",
    twitter: "https://twitter.com/airHQ",
    youtube: "https://www.youtube.com/channel/UCUgwosdkOa7oWs5wacfSTWQ"
};
var AuthRoutes = {
    signUp: "/sign-up",
    login: "/login"
};
var Routes = {
    airFlow: "https://air.inc/air-flow",
    airShop: "https://shop.air.inc/",
    about: "https://air.inc/about",
    adobePremierePro: "https://air.inc/adobe-premiere-pro",
    adobePremiereProDownload: "https://partners.adobe.com/exchangeprogram/creativecloud/exchange.details.107604.html",
    agencies: "https://air.inc/agencies",
    betaProgram: "https://air.inc/beta-program",
    blog: "https://air.inc/blog",
    careers: "https://apply.workable.com/air/",
    contentCleanersDigitalLibraryOrganizers: "https://air.inc/content-cleaners-digital-library-organizers",
    creatorProgram: "https://air.inc/creator-program",
    comparison: "https://air.inc/comparison",
    comparisonBrandExperience: "https://air.inc/comparison/brand-experience",
    comparisonCloudStorageAlternative: "https://air.inc/comparison/cloud-storage-alternative",
    comparisonDigitalAssetManagement: "https://air.inc/comparison/digital-asset-management",
    comparisonDropboxAlternative: "https://air.inc/comparison/dropbox-alternative",
    comparisonGoogleDriveAlternative: "https://air.inc/comparison/google-drive-alternative",
    comparisonBox: "https://air.inc/comparison/box-alternative",
    comparisonDAM: "https://air.inc/comparison/digital-asset-management",
    culture: "https://air.inc/culture",
    cultureManagement: "https://air.inc/culture/management",
    culturePolicies: "https://air.inc/culture/policies",
    customerStories: "https://air.inc/customers",
    demo: "https://calendly.com/john_air/meetjohn",
    departmentDesignCreative: "https://air.inc/department/design-creative",
    departmentMarketing: "https://air.inc/department/marketing",
    departmentGrowth: "https://air.inc/department/growth",
    desktop: "https://air.inc/air-lift",
    diversity: "https://air.inc/culture/diversity",
    download: "https://air.inc/download",
    enterprise: "https://air.inc/enterprise",
    features: "https://air.inc/features",
    featuresDynamicFeedback: "https://air.inc/features/dynamic-feedback",
    featuresFlexibleOrganization: "https://air.inc/features/flexible-organization",
    featuresKanban: "https://air.inc/features/kanban",
    featuresSmartSearch: "https://air.inc/features/smart-search",
    featuresVersions: "https://air.inc/features/versions",
    featuresVisualWorkspace: "https://air.inc/features/visual-workspace",
    flexibleOrganization: "https://air.inc/features/flexible-organization",
    inclusion: "https://air.inc/culture/inclusion",
    industry: "https://air.inc/industry",
    industryAgencies: "https://air.inc/industry/agencies",
    industryAthletics: "https://air.inc/industry/athletics",
    industryEducation: "https://air.inc/industry/education",
    industryMedia: "https://air.inc/industry/media",
    industryNonprofits: "https://air.inc/industry/nonprofits",
    industryRetail: "https://air.inc/industry/retail",
    integrations: "https://air.inc/integrations",
    iphone: "https://apps.apple.com/app/apple-store/id1244558410",
    liveEvents: "https://air.inc/live-events",
    logos: "https://air.inc/logos",
    migrate: "https://air.inc/switch",
    operators: "https://air.inc/operators",
    partnerProgram: "https://air.inc/partner-program",
    pricing: "https://air.inc/pricing",
    privacy: "https://air.inc/legal/privacy",
    releaseNotes: "https://www.notion.so/airinc/What-s-New-on-Air-1d5da1c7779a4e71a94971834d5cdf0e",
    resources: "https://air.inc/resources",
    root: "https://air.inc/",
    security: "https://air.inc/security",
    store: "https://shop.air.inc",
    terms: "https://air.inc/legal/terms",
    tour: "https://air.inc/tour",
    tourCreativeApprovals: "https://air.inc/tour/creative-approvals",
    tourCreativeRequests: "https://air.inc/tour/creative-requests",
    tourOnboardFreelancers: "https://air.inc/tour/onboard-freelancers",
    tourRightsManagement: "https://air.inc/tour/rights-management",
    visualWorkspace: "https://air.inc/features/visual-workspace",
    worthlessStudios: "https://air.inc/blog/worthless-studios",
    /**
   * Landing page routes. Subject to change
   */ semlp1forma: "https://air.inc/landing/sem-lp-form-1",
    semlp1formb: "https://air.inc/landing/sem-lp-form-2",
    semlp1buttona: "https://air.inc/landing/sem-lp-button-1",
    semlp1buttonb: "https://air.inc/landing/sem-lp-button-2"
};
var DynamicRoutes = {
    _sandbox: "/sandbox/[slug]",
    agencies: "/agencies/[slug]",
    comparison: "/comparison/[slug]",
    department: "/department/[slug]",
    features: "/features/[slug]",
    industry: "/industry/[slug]",
    landing: "/landing/[slug]",
    legal: "/legal/[slug]",
    logos: "/logos",
    resources: "/resources/[slug]",
    tour: "/tour/[slug]"
};
var BlogRoutes = {
    archive: "/blog/archive",
    categories: "/blog/category",
    home: "/blog",
    /**
   * These are routes that contains a custom page renderer.
   */ firstagram: "/blog/1stagram",
    nycRooftopBarsRestaurants: "/blog/nyc-rooftop-bars-restaurants",
    nycCreativeCouncil: "/blog/nyc-creative-council",
    sixFeetCalculator: "/blog/6feetcalculator",
    supportNYC: "/blog/supportnycdtc",
    creativeOps: "/blog/category/creative-ops",
    buildingBrands: "/blog/category/building-brands",
    airNews: "/blog/category/air-news"
};
var BlogDynamicRoutes = {
    category: "/blog/category/[slug]",
    post: "/blog/[slug]"
};


/***/ }),

/***/ 89170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ee": function() { return /* reexport */ Anchor; },
  "xu": function() { return /* reexport */ Box; },
  "zx": function() { return /* reexport */ Button; },
  "TR": function() { return /* reexport */ Logo; },
  "xv": function() { return /* reexport */ Text; },
  "TX": function() { return /* reexport */ VisuallyHidden; },
  "jG": function() { return /* reexport */ createTheme; },
  "zo": function() { return /* reexport */ styled; }
});

// UNUSED EXPORTS: AspectRatio, Blockquote, Bold, Divider, HEADING_ELEMENT_TAG, Heading, Input, Italic, ListItem, OrderedList, Paragraph, StyledAdornment, StyledRoot, Underline, UnorderedList, config, css, getCssText, globalCss, globalStyles, keyframes, theme

// EXTERNAL MODULE: ../../node_modules/@stitches/react/dist/index.mjs
var dist = __webpack_require__(43866);
;// CONCATENATED MODULE: ../../packages/primitives/src/colors.ts
var canaries = {
    canary050: "#FFF1B9",
    canary100: "#FFE784",
    canary200: "#FDD778",
    canary300: "#FFBE3C",
    canary400: "#FFAC00",
    canary500: "#FF9D00",
    canary600: "#EF7600",
    canary700: "#CE4D13",
    canary800: "#833602",
    canary900: "#4C2103"
};
var cockatoos = {
    cockatoo025: "#FDD2FF",
    cockatoo050: "#FFAEF9",
    cockatoo100: "#FF83F3",
    cockatoo200: "#FF4AE6",
    cockatoo300: "#FF00D5",
    cockatoo400: "#E004BC",
    cockatoo500: "#B702A0",
    cockatoo600: "#86017C",
    cockatoo700: "#5D034E",
    cockatoo800: "#3E0234"
};
var cuckoos = {
    cuckoo100: "#EDE6FF",
    cuckoo200: "#D7C6FF",
    cuckoo300: "#C1A1FF",
    cuckoo400: "#AC78FF",
    cuckoo500: "#9F5CFF",
    cuckoo600: "#9640FF",
    cuckoo700: "#8029EF",
    cuckoo800: "#5618B7",
    cuckoo900: "#341078"
};
var flamingos = {
    flamingo050: "#FCF0F0",
    flamingo100: "#FFD9D9",
    flamingo200: "#FF9797",
    flamingo300: "#FF6969",
    flamingo400: "#FF5050",
    flamingo500: "#ED3B3B",
    flamingo600: "#D23939",
    flamingo700: "#A1222F",
    flamingo800: "#841328",
    flamingo900: "#511421"
};
var jays = {
    jay020: "#E7F1FF",
    jay050: "#DDE9FF",
    jay100: "#B4CFFF",
    jay150: "#90B8FF",
    jay200: "#6FA2FF",
    jay250: "#448AFF",
    jay300: "#2E77FF",
    jay350: "#2160FF",
    jay400: "#034BFF",
    jay450: "#052DE1",
    jay500: "#0018CC",
    jay600: "#0204A4",
    jay700: "#000177",
    jay800: "#010256",
    jay900: "#020039"
};
var macaws = {
    macaw020: "#E7F1FF",
    macaw040: "#D7E5FF",
    macaw060: "#BFD1FF",
    macaw080: "#91AEFF",
    macaw100: "#667EFF",
    macaw200: "#5466FF",
    macaw300: "#4A51FF",
    macaw350: "#4030FF",
    macaw400: "#3820EA",
    macaw500: "#280DBC",
    macaw600: "#1C0694"
};
var parrots = {
    parrot025: "#DEFABB",
    parrot050: "#C6F68D",
    parrot100: "#AAF255",
    parrot200: "#90EE02",
    parrot300: "#75E900",
    parrot400: "#61D800",
    parrot500: "#41C300",
    parrot600: "#09AF00",
    parrot700: "#008B00",
    parrot800: "#026802"
};
var peacocks = {
    peacock050: "#E6F4F6",
    peacock100: "#CEEDEF",
    peacock200: "#B2ECED",
    peacock300: "#70E8E8",
    peacock400: "#33DBDB",
    peacock500: "#07B3BE",
    peacock600: "#05889F",
    peacock700: "#036280",
    peacock800: "#01486A",
    peacock900: "#033B51"
};
var pigeons = {
    pigeon025: "#F7F7F7",
    pigeon050: "#EFEFEF",
    pigeon100: "#DCDCDC",
    pigeon200: "#C1C1C1",
    pigeon300: "#A4A4A4",
    pigeon400: "#808080",
    pigeon500: "#666666",
    pigeon600: "#4D4D4D",
    pigeon650: "#3F3E3E",
    pigeon700: "#333333",
    pigeon800: "#262626",
    pigeon850: "#1A1A1A",
    pigeon900: "#0F0F0F"
};
var robins = {
    robin300: "#FFAA3B",
    robin400: "#FF9800",
    robin500: "#FB8800",
    robin600: "#FB7D00",
    robin700: "#FF6D00"
};

;// CONCATENATED MODULE: ../../packages/primitives/src/stitches.config.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ref = (0,dist/* createStitches */.Th)({
    theme: {
        colors: _objectSpread({
            black: "#000000",
            white: "#FFFFFF"
        }, canaries, cockatoos, cuckoos, flamingos, jays, macaws, parrots, peacocks, pigeons, robins),
        fontWeights: {
            light: "300",
            regular: "400",
            medium: "500",
            semibold: "600",
            bold: "700"
        },
        fonts: {
            display: "Gelica, Georgia, serif",
            // Cross-platform font stacks found here: github.com/csstools/sanitize.css#typography
            copy: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            monospace: 'Menlo, Consolas, Roboto Mono, "Ubuntu Monospace", "Noto Mono", "Oxygen Mono", "Liberation Mono", monospace'
        }
    },
    media: {
        desktopLarge: "(min-width: 1200px)",
        desktop: "(min-width: 1024px)",
        laptop: "(min-width: 768px)",
        reducedMotion: "(prefers-reduced-motion)",
        tablet: "(min-width: 480px)"
    },
    utils: {
        paddingX: function(value) {
            return {
                paddingLeft: value,
                paddingRight: value
            };
        },
        paddingY: function(value) {
            return {
                paddingTop: value,
                paddingBottom: value
            };
        },
        marginX: function(value) {
            return {
                marginLeft: value,
                marginRight: value
            };
        },
        marginY: function(value) {
            return {
                marginTop: value,
                marginBottom: value
            };
        }
    }
});
var styled = ref.styled, css = ref.css, globalCss = ref.globalCss, keyframes = ref.keyframes, getCssText = ref.getCssText, theme = ref.theme, createTheme = ref.createTheme, config = ref.config;
var globalStyles = globalCss({
    body: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale"
    },
    "*": {
        boxSizing: "border-box",
        margin: 0
    }
});

;// CONCATENATED MODULE: ../../packages/primitives/src/Anchor.ts

var Anchor = styled("a", {
    color: "$jay500",
    fontFamily: "$copy",
    fontWeight: "semibold",
    wordBreak: "break-word",
    textDecoration: "none",
    cursor: "pointer",
    transition: "color 0.2s ease, text-decoration 0.2s ease",
    "&:focus, &:hover": {
        textDecoration: "underline"
    },
    "&:focus": {
        outline: "none"
    },
    "&:focus-visible": {
        boxShadow: "0 0 0 2px $colors$macaw100"
    }
});

// EXTERNAL MODULE: ../../packages/primitives/node_modules/@radix-ui/react-aspect-ratio/dist/index.module.js + 3 modules
var index_module = __webpack_require__(79342);
;// CONCATENATED MODULE: ../../packages/primitives/src/AspectRatio.tsx

var AspectRatio = index_module/* Root */.f;

;// CONCATENATED MODULE: ../../packages/primitives/src/Blockquote.tsx

var Blockquote = styled("blockquote", {});

;// CONCATENATED MODULE: ../../packages/primitives/src/Bold.ts

var Bold = styled("strong", {
    fontWeight: "medium"
});

;// CONCATENATED MODULE: ../../packages/primitives/src/Box.ts

var Box = styled("div", {
    margin: 0,
    boxSizing: "border-box"
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/primitives/src/Button.tsx
function Button_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Button_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Button_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var _obj, _obj1;
var StyledRoot = styled("button", {
    appearance: "none",
    outline: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$button$test",
    border: 0,
    borderRadius: 4,
    margin: 0,
    boxSizing: "border-box",
    fontFamily: "$copy",
    fontWeight: "$semibold",
    lineHeight: 1,
    textDecoration: "none",
    cursor: "pointer",
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover": {
        textDecoration: "none"
    },
    "&:focus-visible": {
        boxShadow: "0 0 0 2px $colors$focus"
    },
    "&:disabled": {
        cursor: "not-allowed"
    },
    "&[data-loading]": {
        cursor: "progress"
    },
    variants: {
        appearance: {
            filled: {
                "&:disabled:not([data-loading])": {
                    backgroundColor: "$pigeon025",
                    color: "$pigeon300"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                "&:disabled:not([data-loading])": {
                    backgroundColor: "transparent",
                    color: "$pigeon300"
                }
            },
            outline: {
                backgroundColor: "transparent",
                border: "1px solid $colors$pigeon200",
                "&:disabled:not([data-loading])": {
                    backgroundColor: "transparent",
                    border: "1px solid $colors$pigeon200",
                    color: "$pigeon500"
                }
            }
        },
        color: (_obj = {}, Button_defineProperty(_obj, "jay500", {}), Button_defineProperty(_obj, "macaw350", {}), Button_defineProperty(_obj, "macaw060", {}), Button_defineProperty(_obj, "pigeon050", {}), Button_defineProperty(_obj, "destructive", {}), _obj),
        size: (_obj1 = {}, Button_defineProperty(_obj1, "extra-small", {
            height: 24,
            paddingX: 8,
            fontSize: 12
        }), Button_defineProperty(_obj1, "small", {
            height: 32,
            paddingX: 10,
            fontSize: 14
        }), Button_defineProperty(_obj1, "medium", {
            height: 40,
            paddingX: 12,
            fontSize: 16
        }), Button_defineProperty(_obj1, "large", {
            height: 48,
            paddingX: 24,
            fontSize: 16
        }), _obj1)
    },
    compoundVariants: [
        {
            appearance: "filled",
            color: "jay500",
            css: {
                backgroundColor: "$jay500 !important",
                border: 0,
                color: "$white",
                "&:hover:not([data-loading])": {
                    backgroundColor: "$jay600"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "$jay700"
                }
            }
        },
        {
            appearance: "filled",
            color: "macaw350",
            css: {
                backgroundColor: "$macaw350",
                border: 0,
                color: "$white",
                "&:hover:not([data-loading])": {
                    backgroundColor: "$macaw400"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "$macaw500"
                }
            }
        },
        {
            appearance: "filled",
            color: "macaw060",
            css: {
                backgroundColor: "$macaw060",
                border: 0,
                color: "$macaw600",
                "&:hover:not([data-loading])": {
                    backgroundColor: "$macaw080"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "$macaw100"
                }
            }
        },
        {
            appearance: "filled",
            color: "pigeon050",
            css: {
                backgroundColor: "$pigeon050",
                color: "$pigeon600",
                "&:hover:not([data-loading])": {
                    backgroundColor: "$pigeon100"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "$pigeon200",
                    color: "$pigeon700"
                }
            }
        },
        {
            appearance: "filled",
            color: "destructive",
            css: {
                backgroundColor: "$flamingo600",
                color: "$white",
                "&:hover:not([data-loading])": {
                    backgroundColor: "$flamingo700"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "$flamingo800"
                }
            }
        },
        {
            appearance: "ghost",
            color: "jay500",
            css: {
                color: "$jay600",
                "&:hover:not([data-loading])": {
                    backgroundColor: "rgba(46, 119, 255, 0.15)",
                    color: "$jay600"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "rgba(46, 119, 255, 0.3",
                    color: "$jay600"
                }
            }
        },
        {
            appearance: "ghost",
            color: "pigeon050",
            css: {
                color: "$pigeon600",
                "&:hover:not([data-loading])": {
                    backgroundColor: "rgba(38, 38, 38, 0.1)"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "rgba(38, 38, 38, 0.15)"
                }
            }
        },
        {
            appearance: "ghost",
            color: "destructive",
            css: {
                color: "$flamingo700",
                "&:hover:not([data-loading])": {
                    backgroundColor: "rgba(255, 105, 105, 0.15)"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "rgba(255, 105, 105, 0.25)"
                }
            }
        },
        {
            appearance: "outline",
            color: "$jay500",
            css: {
                borderColor: "$jay600",
                color: "$jay600",
                "&:hover:not([data-loading])": {
                    backgroundColor: "rgba(46, 119, 255, 0.15)"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "rgba(46, 119, 255, 0.3)"
                }
            }
        },
        {
            appearance: "outline",
            color: "macaw350",
            css: {
                color: "$macaw350",
                "&:hover:not([data-loading])": {
                    backgroundColor: "$macaw060",
                    color: "$macaw500"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "$macaw080",
                    color: "$macaw600"
                }
            }
        },
        {
            appearance: "outline",
            color: "pigeon050",
            css: {
                borderColor: "$pigeon500",
                color: "$pigeon600",
                "&:hover:not([data-loading])": {
                    backgroundColor: "rgba(38, 38, 38, 0.1)"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "rgba(38, 38, 38, 0.15)"
                }
            }
        },
        {
            appearance: "outline",
            color: "destructive",
            css: {
                borderColor: "$flamingo700",
                color: "$flamingo700",
                "&:hover:not([data-loading])": {
                    backgroundColor: "rgba(255, 105, 105, 0.15)"
                },
                "&:active:not([data-loading])": {
                    backgroundColor: "rgba(255, 105, 105, 0.25)"
                }
            }
        }, 
    ],
    defaultVariants: {
        appearance: "filled",
        color: "jay500",
        size: "medium"
    }
});
var _obj2;
var StyledAdornment = styled("div", {
    variants: {
        side: {
            left: {
                marginRight: 4,
                marginLeft: -4
            },
            right: {
                marginRight: -4,
                marginLeft: 4
            }
        },
        size: (_obj2 = {}, Button_defineProperty(_obj2, "extra-small", {}), Button_defineProperty(_obj2, "small", {}), Button_defineProperty(_obj2, "medium", {}), Button_defineProperty(_obj2, "large", {}), _obj2)
    },
    compoundVariants: [
        {
            side: "left",
            size: "extra-small",
            css: {
                marginLeft: -2
            }
        },
        {
            side: "right",
            size: "extra-small",
            css: {
                marginRight: -2
            }
        }, 
    ]
});
var bounceKeyframe = keyframes({
    "0%": {
        transform: "translate(0, -1.5px)"
    },
    "50%": {
        transform: "translate(0, 1.5px)"
    },
    "100%": {
        transform: "translate(0, -1.5px)"
    }
});
var StyledLoaderDot = styled("div", {
    backgroundColor: "currentColor",
    width: 4,
    height: 4,
    borderRadius: 4,
    animation: "".concat(bounceKeyframe, " 980ms ease-in-out")
});
var StyledLoader = styled("div", Button_defineProperty({
    position: "absolute",
    top: "50%",
    left: "50%",
    display: "flex",
    transform: "translate(-50%, -50%)"
}, "& ".concat(StyledLoaderDot), {
    animation: "".concat(bounceKeyframe, " 980ms ease-in-out 0s both infinite"),
    "&:nth-of-type(1)": {
        animationDelay: "0s"
    },
    "&:nth-of-type(2)": {
        marginX: 4,
        animationDelay: "0.14s"
    },
    "&:nth-of-type(3)": {
        animationDelay: "0.28s"
    },
    "@reducedMotion": {
        animationName: "none"
    }
}));
var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var adornmentLeft = _param.adornmentLeft, adornmentRight = _param.adornmentRight, _appearance = _param.appearance, appearance = _appearance === void 0 ? "filled" : _appearance, children = _param.children, className = _param.className, _color = _param.color, color = _color === void 0 ? "jay500" : _color, css = _param.css, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, onClick = _param.onClick, _size = _param.size, size = _size === void 0 ? "medium" : _size, _type = _param.type, type = _type === void 0 ? "button" : _type, restOfProps = _objectWithoutProperties(_param, [
        "adornmentLeft",
        "adornmentRight",
        "appearance",
        "children",
        "className",
        "color",
        "css",
        "disabled",
        "isLoading",
        "onClick",
        "size",
        "type"
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            adornmentLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAdornment, {
                side: "left",
                size: size,
                children: adornmentLeft
            }),
            children,
            adornmentRight && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAdornment, {
                side: "right",
                size: size,
                children: adornmentRight
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRoot, Button_objectSpread({
        appearance: appearance,
        className: className,
        color: color,
        css: css,
        disabled: disabled,
        "data-loading": isLoading ? "" : undefined,
        onClick: onClick,
        ref: forwardedRef,
        size: size,
        type: type
    }, restOfProps, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
            css: {
                position: "relative"
            },
            role: "status",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLoader, {
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoaderDot, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoaderDot, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoaderDot, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                    "aria-hidden": "true",
                    css: {
                        opacity: 0,
                        visibility: "hidden"
                    },
                    children: content
                })
            ]
        }) : content
    }));
});

Button.displayName = "Button";

;// CONCATENATED MODULE: ../../packages/primitives/src/Divider.ts

var Divider = styled("hr", {
    height: 1,
    border: 0,
    borderBottom: "1px solid",
    borderColor: "$pigeon025"
});

;// CONCATENATED MODULE: ../../packages/primitives/src/Text.ts

var Text = styled("span", {
    minWidth: 0,
    fontFamily: "$copy",
    variants: {
        size: {
            "heading-80": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 80,
                letterSpacing: "0.02em",
                lineHeight: 1.1
            },
            "heading-72": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 72,
                letterSpacing: "0.02em",
                lineHeight: 1.1
            },
            "heading-64": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 64,
                letterSpacing: "0.02em",
                lineHeight: 1.1
            },
            "heading-56": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 56,
                letterSpacing: "0.03em",
                lineHeight: 1.16
            },
            "heading-48": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 48,
                letterSpacing: "0.03em",
                lineHeight: 1.16
            },
            "heading-40": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 40,
                letterSpacing: "0.03em",
                lineHeight: 1.15
            },
            "heading-32": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 32,
                letterSpacing: "0.03em",
                lineHeight: 1.1
            },
            "heading-28": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 28,
                letterSpacing: "0.03em",
                lineHeight: 1.1
            },
            "heading-24": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 24,
                letterSpacing: "0.03em",
                lineHeight: 1.1
            },
            "heading-20": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 20,
                letterSpacing: "0.03em",
                lineHeight: 1.1
            },
            "heading-18": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 18,
                letterSpacing: "0.03em",
                lineHeight: 1.1
            },
            "heading-16": {
                fontFamily: "$display",
                fontFeatureSettings: "'salt' on, 'ss01' on",
                fontSize: 16,
                letterSpacing: "0.03em",
                lineHeight: 1.1
            },
            "ui-10": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 10,
                letterSpacing: "0.01em",
                lineHeight: 1.2
            },
            "ui-12": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 12,
                letterSpacing: "initial",
                lineHeight: 1.5
            },
            "ui-14": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 14,
                letterSpacing: "-0.006em",
                lineHeight: "20px"
            },
            "ui-16": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 16,
                letterSpacing: "-0.011em",
                lineHeight: 1.5
            },
            "ui-18": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 18,
                letterSpacing: "-0.014em",
                lineHeight: "24px"
            },
            "ui-20": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 20,
                letterSpacing: "-0.017em",
                lineHeight: 1.3
            },
            "ui-24": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 24,
                letterSpacing: "-0.019em",
                lineHeight: 1.2
            },
            "ui-32": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 32,
                letterSpacing: "-0.021em",
                lineHeight: 1.2
            },
            "ui-36": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 36,
                letterSpacing: "-0.022em",
                lineHeight: 1.2
            },
            "ui-40": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 40,
                letterSpacing: "-0.022em",
                lineHeight: 1.2
            },
            "ui-48": {
                fontFamily: "$copy",
                fontFeatureSettings: "'case' on",
                fontSize: 48,
                letterSpacing: "-0.022em",
                lineHeight: 1.2
            },
            inherit: {
                fontFamily: "inherit",
                fontFeatureSettings: "inherit",
                fontSize: "inherit",
                letterSpacing: "inherit",
                lineHeight: "inherit"
            }
        },
        transform: {
            none: {
                textTransform: "none"
            },
            uppercase: {
                textTransform: "uppercase"
            }
        },
        weight: {
            light: {
                fontWeight: "$light"
            },
            regular: {
                fontWeight: "$regular"
            },
            medium: {
                fontWeight: "$medium"
            },
            semibold: {
                fontWeight: "$semibold"
            },
            bold: {
                fontWeight: "$bold"
            }
        }
    },
    compoundVariants: [
        {
            size: "ui-10",
            transform: "uppercase",
            css: {
                fontFeatureSettings: "'pnum' on, 'lnum' on, 'ss01' on",
                letterSpacing: "0.04em"
            }
        },
        {
            size: "ui-12",
            transform: "uppercase",
            css: {
                fontFeatureSettings: "'pnum' on, 'lnum' on, 'ss01' on",
                letterSpacing: "0.03em"
            }
        },
        {
            size: "ui-14",
            transform: "uppercase",
            css: {
                fontFeatureSettings: "'cpsp' on, 'case' on",
                letterSpacing: "0.04em"
            }
        },
        {
            size: "ui-16",
            transform: "uppercase",
            css: {
                fontFeatureSettings: "'case' on",
                letterSpacing: "0.05em"
            }
        },
        {
            size: "ui-18",
            transform: "uppercase",
            css: {
                fontFeatureSettings: "'case' on",
                letterSpacing: "0.05em"
            }
        }, 
    ],
    defaultVariants: {
        size: "ui-16",
        transform: "none"
    }
});

;// CONCATENATED MODULE: ../../packages/primitives/src/Heading.tsx
function Heading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Heading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Heading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Heading_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Heading_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Heading_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var HEADING_ELEMENT_TAG = "h1";
var Heading = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var children = _param.children, _hierarchy = _param.hierarchy, hierarchy = _hierarchy === void 0 ? 1 : _hierarchy, _weight = _param.weight, weight = _weight === void 0 ? "semibold" : _weight, restOfProps = Heading_objectWithoutProperties(_param, [
        "children",
        "hierarchy",
        "weight"
    ]);
    var elementTag = "h".concat(hierarchy);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, Heading_objectSpread({
        as: elementTag,
        weight: weight
    }, restOfProps, {
        ref: forwardedRef,
        children: children
    }));
});

Heading.displayName = "Heading";

;// CONCATENATED MODULE: ../../packages/primitives/src/Input.ts
function Input_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var Input_obj;
var Input = styled("input", {
    outline: 0,
    width: "100%",
    border: "1px solid $colors$pigeon200",
    borderRadius: 4,
    color: "$pigeon700",
    fontFamily: "$copy",
    letterSpacing: "-0.015em",
    lineHeight: 1.5,
    "&:disabled": {
        opacity: 0.75,
        cursor: "not-allowed"
    },
    "&:focus": {
        borderColor: "$macaw200"
    },
    variants: {
        size: (Input_obj = {}, Input_defineProperty(Input_obj, "extra-small", {
            height: 24,
            paddingX: 8,
            fontSize: 12
        }), Input_defineProperty(Input_obj, "small", {
            height: 32,
            paddingX: 10,
            fontSize: 14
        }), Input_defineProperty(Input_obj, "medium", {
            height: 40,
            paddingX: 12,
            fontSize: 16
        }), Input_defineProperty(Input_obj, "large", {
            height: 48,
            paddingX: 24,
            fontSize: 16
        }), Input_obj)
    },
    defaultVariants: {
        size: "medium"
    }
});

;// CONCATENATED MODULE: ../../packages/primitives/src/Italic.ts

var Italic = styled("em", {
    fontStyle: "italic"
});

;// CONCATENATED MODULE: ../../packages/primitives/src/ListItem.ts

var ListItem = styled("li", {});

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-visually-hidden/dist/index.module.js
var dist_index_module = __webpack_require__(19401);
;// CONCATENATED MODULE: ../../packages/primitives/src/VisuallyHidden.ts

var VisuallyHidden = dist_index_module/* Root */.f;

;// CONCATENATED MODULE: ../../packages/primitives/src/Logo.tsx




var Logo_StyledRoot = styled("a", {
    display: "inline-block",
    height: 24,
    svg: {
        display: "block",
        height: "100%"
    }
});
var Logo = function(param) {
    var css = param.css, _href = param.href, href = _href === void 0 ? "https://air.inc" : _href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Logo_StyledRoot, {
            css: css,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden, {
                    children: "Air"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 350 144",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fillRule: "evenodd",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M147.617 58.488c2.45-12.67 3.492-23.619 3.492-29.919C151.109 4.956 140.365 0 131.353 0c-19.144 0-46.195 22.141-82.697 67.69-26.076 32.537-47.432 65.52-47.644 65.848a6.312 6.312 0 001.878 8.73 6.313 6.313 0 008.729-1.88c31.903-49.395 92.62-127.76 119.734-127.76 2.133 0 7.127 0 7.127 15.941 0 6.227-1.14 17.313-3.735 29.957 0 0 7.343-.247 12.872-.038M222.43 46.512c0 5.486-4.448 9.934-9.935 9.934-5.486 0-9.933-4.448-9.933-9.934 0-5.486 4.447-9.934 9.933-9.934 5.487 0 9.934 4.448 9.934 9.934"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M251.376 92.738A114.675 114.675 0 01240 106.315c-15.33 15.69-33.125 25.056-47.6 25.056-7.453 0-11.232-3.186-11.232-9.47 0-6.645 3.645-19.298 21.007-41.839a6.317 6.317 0 00.874-6.162 6.318 6.318 0 00-4.835-3.918l-.005.005.005-.032C155.506 62.806 98.435 59.5 69.084 84.343v.028c-14.632 12.386-15.769 26.242-15.769 30.193 0 16.771 12.775 29.416 29.715 29.416 23.02 0 41.912-17.346 54.635-50.16a178.444 178.444 0 003.562-10.148c-4.67.008-9.163.167-13.443.471-8.538 24.562-22.77 47.208-44.754 47.208-11.217 0-17.086-8.444-17.086-16.787 0-5.312 2.968-13.502 11.3-20.555v-.027C90.721 82.574 120.5 71.41 185.925 80.832c-11.674 16.66-17.385 30.171-17.385 41.07 0 16.311 12.854 22.098 23.86 22.098 18.07 0 38.711-10.519 56.633-28.859 5.863-6 10.964-12.365 15.165-18.795-8.24-.465-12.822-3.608-12.822-3.608"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M348.148 112.738a6.313 6.313 0 00-8.911-.57c-13.861 12.191-28.13 19.183-39.145 19.183-6.54 0-9.855-3.423-9.855-10.175 0-7.297 3.914-21.077 22.555-45.278a6.316 6.316 0 00-8.602-9.04l-.001.001v-.002c-9.404 6.526-23.156 10.91-34.221 10.91-14.007 0-20.388-8.516-20.388-16.43 0-9.635 4.978-12.18 7.61-12.18 6.767 0 7.467 7.511 7.52 9.813.079 3.452-.551 7.291-1.782 11.353 0 0 6.119 2.153 12.876.698 1.083-4.318 1.62-8.47 1.53-12.343-.301-13.042-8.584-22.15-20.143-22.15-10.058 0-20.24 8.522-20.24 24.81 0 8.815 3.835 16.61 10.796 21.945 5.984 4.587 13.876 7.112 22.22 7.112 6.21 0 12.962-1.07 19.564-2.993l-.001.001c-7.923 13.21-11.921 24.52-11.921 33.773 0 15.753 11.292 22.804 22.483 22.804 19.226 0 38.003-13.99 47.486-22.33a6.312 6.312 0 00.57-8.912"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/primitives/src/OrderedList.ts

var OrderedList = styled("ol", {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    paddingLeft: 24
});

;// CONCATENATED MODULE: ../../packages/primitives/src/Paragraph.tsx
function Paragraph_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Paragraph_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Paragraph_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Paragraph_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Paragraph_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Paragraph_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Paragraph = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, restOfProps = Paragraph_objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, Paragraph_objectSpread({
        as: "p"
    }, restOfProps, {
        ref: ref,
        children: children
    }));
});

Paragraph.displayName = "Paragraph";

;// CONCATENATED MODULE: ../../packages/primitives/src/Underline.ts

var Underline = styled("u", {
    textDecoration: "underline"
});

;// CONCATENATED MODULE: ../../packages/primitives/src/UnorderedList.ts

var UnorderedList = styled("ul", {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 24,
    gap: 16
});

;// CONCATENATED MODULE: ../../packages/primitives/src/index.tsx





















/***/ })

}]);